import { WaterlilyClient } from '@client/api/waterlily';

export interface FormReferenceForClient {
  formReferenceId: string;
  formLink: string;
}

export interface ProvisionIntakeAccessData {
  email: string;
  firstName?: string;
  lastName?: string;
}

export const sendReminderApi = {
  fetchFormReference: (clientId: string) =>
    WaterlilyClient.get<FormReferenceForClient>(`/client/${clientId}/form-reference`),

  persistIntakeFormUrl: (clientId: string, intakeFormUrl: string, clientEmail?: string) =>
    WaterlilyClient.put(`/client/${clientId}`, { clientId, intakeFormUrl, clientEmail }),

  // Backfills the form-reference email + provisions a passwordless client account so
  // the emailed sign-in link works for clients created without an email (e.g. SelfFill).
  provisionIntakeAccess: (clientId: string, data: ProvisionIntakeAccessData) =>
    WaterlilyClient.post<{ success: boolean }>(`/client/${clientId}/intake-access`, {
      clientId,
      ...data,
    }),
};
